<template>
    <!-- <div class="syshead">
        <div id="ulCallOptions">
            <audio id="audio_remote" autoplay></audio>
            <audio id="ringtone" loop src="@/assets/laoshidianhua.mp3"></audio>
            <audio id="ringbacktone" loop src="@/assets/ringbacktone.wav"></audio>
            <audio id="dtmfTone" src="@/assets/dtmf.wav"></audio>
            <audio id="jietong" src="@/assets/jietong.mp3"></audio>
        </div>
        <div class="line">
            <view v-show="loginFlag == 1" class="fs-50" style="width: 20%;display: flex;">
                <view v-show="sip_status == 1" @click="busyButton">
                    <u-image src="@/assets/idel.png" width="50upx" height="50upx"></u-image>
                </view>
                <view v-show="sip_status == 2" @click="idleButton">
                    <u-image src="@/assets/busy.png" width="50upx" height="50upx"></u-image>
                </view>
            </view>
            <view v-show="loginFlag == 2" class="fs-50" style="width: 20%;display: flex;">
                <view>
                    <u-image src="@/assets/offline.png" width="50upx" height="50upx"></u-image>
                </view>
            </view>

            <view class="topic fnw fs-50" style="width: 60%;display: flex;justify-content: center;">
                <view>
                    <span style="vertical-align: middle">sip</span>
                    <u-image src="@/assets/select.png" width="40upx" height="40upx"
                        style="display: inline-block;margin-left: 15upx;vertical-align: middle"></u-image>
                </view>
            </view>

            <view v-show="loginFlag == 1" @click="toggleSwitch()" class="fs-50"
                style="width: 20%;display: flex;justify-content: flex-end;">
                <u-button v-show="auto_response == 1" shape="circle" type="success"
                    style="font-size: 20upx;padding: 10upx;height: 70%;">应答 :
                    开</u-button>
                <u-button v-show="auto_response == 2" shape="circle" type="warning"
                    style="font-size: 20upx;padding: 10upx;height: 70%;">应答 :
                    关</u-button>
            </view>
            <view v-show="loginFlag == 2" class="fs-50" style="width: 20%;">
                <u-button shape="circle" type="primary" @click="againLogin"
                    style="font-size: 20upx;padding: 10upx;height: 70%;">重新登录</u-button>
            </view>
        </div>
        <div id="phone-number" style="text-align: center;font-weight: 500;margin-top: 10px;font-size: 20px;">
            {{ phone }}
        </div>
        <div>
            <div class="content">
                <div class="keyboard">
                    <div class="item" onclick="pressKey(1)">
                        <div class="nums">
                            <div class="tit">1</div>
                            <div class="txt">&</div>
                        </div>
                    </div>
                    <div class="item" onclick="pressKey(2)">
                        <div class="nums">
                            <div class="tit">2</div>
                            <div class="txt">ABC</div>
                        </div>
                    </div>
                    <div class="item" onclick="pressKey(3)">
                        <div class="nums">
                            <div class="tit">3</div>
                            <div class="txt">DEF</div>
                        </div>
                    </div>
                    <div class="item" onclick="pressKey(4)">
                        <div class="nums">
                            <div class="tit">4</div>
                            <div class="txt">GHI</div>
                        </div>
                    </div>
                    <div class="item" onclick="pressKey(5)">
                        <div class="nums">
                            <div class="tit">5</div>
                            <div class="txt">JKL</div>
                        </div>
                    </div>
                    <div class="item" onclick="pressKey(6)">
                        <div class="nums">
                            <div class="tit">6</div>
                            <div class="txt">MNO</div>
                        </div>
                    </div>
                    <div class="item" onclick="pressKey(7)">
                        <div class="nums">
                            <div class="tit">7</div>
                            <div class="txt">PQRS</div>
                        </div>
                    </div>
                    <div class="item" onclick="pressKey(8)">
                        <div class="nums">
                            <div class="tit">8</div>
                            <div class="txt">TUV</div>
                        </div>
                    </div>
                    <div class="item" onclick="pressKey(9)">
                        <div class="nums">
                            <div class="tit">9</div>
                            <div class="txt">WXYZ</div>
                        </div>
                    </div>
                    <div class="item" onclick="pressKey('*')">
                        <div class="nums">
                            <div class="tit">*</div>
                        </div>
                    </div>
                    <div class="item" onclick="pressKey(0)">
                        <div class="nums">
                            <div class="tit">0</div>
                        </div>
                    </div>
                    <div class="item" onclick="pressKey('#')">
                        <div class="nums">
                            <div class="tit">#</div>
                        </div>
                    </div>
                </div>
                <div class="oper">
                    <div style="width:40px;height:40px"></div>
                    <div id="call-button">
                        <img src="@/assets/call.png" width="65px" height="65px">
                    </div>
                    <div id="guji-button">
                        <img src="@/assets/guaduan.png" width="65px" height="65px">
                    </div>
                    <div onclick="isBack()">
                        <img id="back" src="@/assets/back.png" width="40px" height="40px">
                    </div>
                </div>
            </div>
        </div>

    </div> -->
    <div>
        
    </div>
</template>
<script>
import {
    mapMutations,
    mapState
} from 'vuex';
import {
    workerSipState,
    workerAnswerStatus
} from '@/api/sip'
export default {
    data() {
        return {
            phone:''
        }
    },
    computed: {
        ...mapState(['auto_response','loginFlag','sip_status'])
    },
    mounted() {

    },
    methods: {
        //sip电话置忙
        busyButton() {
            this.$confirm('切换为忙碌状态！是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                const resData = await workerSipState({ line_status: 2 })
                if (resData.code == 1) {
                    const sipAccountLite = JSON.parse(localStorage.getItem("userInfo"))
                    sipAccountLite.line_status = 2
                    localStorage.setItem('userInfo', JSON.stringify(sipAccountLite))
                    this.$store.commit('getSipStatus', 2)
                }
            }).catch(() => { });
        },
        // sip电话置闲
        idleButton() {
            this.$confirm('切换为空闲状态！是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                const resData = await workerSipState({ line_status: 1 })
                if (resData.code == 1) {
                    const sipAccountLite = JSON.parse(localStorage.getItem("userInfo"))
                    this.$store.commit('getSipStatus', 1)
                    localStorage.setItem('userInfo', JSON.stringify(sipAccountLite))

                }
            }).catch(() => { });
        },
        // 切换自动应答
        toggleSwitch() {
            if (this.auto_response = 1) {
                this.$confirm('关闭自动应答！是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(async () => {
                    const res = await workerAnswerStatus({ status: 0 })
                    if (res.code == 1) {
                        const sipAccountLite = JSON.parse(localStorage.getItem("userInfo"))
                        sipAccountLite.answer = 0
                        localStorage.setItem('userInfo', JSON.stringify(sipAccountLite))
                        this.$store.commit('getAutoResponse', false);
                    } else {
                        this.$message.error(res.msg)
                    }
                }).catch(() => { });
            } else {
                this.$confirm('开启自动应答！是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(async () => {
                    const res = await workerAnswerStatus({ status: 1 })
                    if (res.code == 1) {
                        const sipAccountLite = JSON.parse(localStorage.getItem("userInfo"))
                        sipAccountLite.answer = 1
                        localStorage.setItem('userInfo', JSON.stringify(sipAccountLite))
                        this.$store.commit('getAutoResponse', true);
                    } else {
                        this.$message.error(res.msg)
                    }
                }).catch(() => { });

            }
        },
        //重新登陆
        againLogin(){

        }
    }
}
</script>
<style scoped lang="scss">
body {
    padding: 0;
    margin: 0;
}

#call-button {
    display: block;
}

#guji-button {
    display: none;
}

#btn-relogin {
    background-color: #409eff !important;
    border: 0 !important;
    padding: 3px 13px;
    color: #fff;
    border-radius: 30% 30% 30% 30% / 100%;
    font-size: 14px;
}

.response-on {
    background-color: #67c23a !important;
    border: 0 !important;
    padding: 3px 13px;
    color: #fff;
    border-radius: 30% 30% 30% 30% / 100%;
    font-size: 14px;
}

.response-off {
    background-color: #e6a23c !important;
    border: 0 !important;
    padding: 3px 13px;
    color: #fff;
    border-radius: 30% 30% 30% 30% / 100%;
    font-size: 14px;
}

.syshead {
    width: 100%;
}

.nums {
    width: calc(33.3333% - 20px);
    /* 调整为适应容器 */
    height: 60px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
}

.content {
    width: 100%;
    /* 使用相对宽度 */
    position: fixed;
    bottom: 0px;
    border-top: 1px solid #EBEEF5;
    z-index: 99;
    background-color: #fff;
    box-sizing: border-box;
    color: #000;
}

.keyboard {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
    padding: 0 15px;
    /* 减少内边距 */
}

.item {
    text-align: center;
    width: calc(33.3333% - 10px);
    /* 调整为适应容器 */
    height: 60px;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
}

.tit {
    width: 100%;
    font-size: 24px !important;
    font-weight: bolder;
}

.txt {
    font-size: 16px;
}

.oper {
    margin-bottom: 10px;
    display: flex;
    align-items: center;
    justify-content: space-evenly;
}

.syshead {
    position: fixed;
    top: 0;
    z-index: 999;
    box-sizing: border-box;
}

.task {
    font-size: 15px;
    color: #50BC79;
    margin-left: 5px;
}

.line {
    width: 100%;
    /* 使用相对宽度 */
    display: flex;
    justify-content: space-between;
    padding: 5px 5px 0;
    box-sizing: border-box;
}

.fnw {
    font-style: italic;
}
</style>